const errorMessages = {
  'default': {
    title: 'Something wrong',
    message: 'Something wrong. Please get in touch with support.'
  },
  'password_not_meet_criteria': {
    title: 'Password not meet criteria',
    message: 'The password you provided does not meet criteria.'
  },
  'forget_password_request_not_found': {
    title: 'Forget Password Request not found',
    message: 'Forget password request not found. Please send a new request.'
  },
  'no_valid_user_found': {
    title: 'No valid user found',
    message: 'We could not locate a user matching information you provided. Please get in touch with support.'
  },
  'failed_send_email_with_mailgun': {
    title: 'Failed to send an email',
    message: 'Failed to send an email. Please get in touch with support.'
  },
  'failed_create_password_entry': {
    title: 'Failed to create password entry',
    message: 'Failed to create password entry. Please get in touch with support.'
  },
  'failed_insert_emailoutgoing': {
    title: 'Failed to insert email outgoing record',
    message: 'Failed to insert email outgoing record. Please get in touch with support.'
  },
  'password_reset_link_expired': {
    title: 'Expired password reset link',
    message: 'The password reset link has expired. Please send a new request.'
  },
  'password_reset_link_used': {
    title: 'Used password reset link',
    message: 'The password reset link has already been used. Please send a new request.'
  },
  'not_valid_user_token': {
    title: 'Invalid user token',
    message: 'Not valid user. Please contact support.'
  }
}

export const getErrorMessage = (errorCode) => {
  return errorMessages[errorCode] || errorMessages['default']
}

/**
 * Text to show for a failed sign-in call.
 *
 * Distinct from getErrorMessage above, which maps known error *codes* to friendly copy. The
 * sign-in endpoints instead return literal user-facing strings ("Invalid credentials, you have
 * 3 remaining attempts", "You have been locked out. Try again in ...") deliberately matched to
 * the wording of the legacy login page, so the server's message is the message to display.
 *
 * ASP.NET Web API serialises Request.CreateErrorResponse as {"Message": "..."}, but the shape
 * varies across the endpoints and proxies involved, so each known form is checked in turn.
 *
 * A few of these endpoints do return a bare code rather than prose - the password-change path
 * surfaces 'password_not_meet_criteria' straight from UpdateUserPassword - so anything matching
 * a known code is translated rather than shown to the user verbatim.
 */
export const getApiErrorMessage = (error, fallback) => {
  const data = error && error.response ? error.response.data : null
  let raw = null

  if (typeof data === 'string' && data.trim()) {
    raw = data
  } else if (data) {
    if (typeof data.Message === 'string' && data.Message.trim()) raw = data.Message
    else if (typeof data.message === 'string' && data.message.trim()) raw = data.message
    else if (typeof data.ExceptionMessage === 'string' && data.ExceptionMessage.trim()) raw = data.ExceptionMessage
  }

  if (!raw) return fallback || 'Something went wrong. Please try again.'

  const trimmed = raw.trim()
  return errorMessages[trimmed] ? errorMessages[trimmed].message : trimmed
}